import { TFunction } from "i18next";
import * as Yup from "yup";

import { DayOfWeek } from "@/api";
import {
  AttendanceEntryFormValues,
  WeeklySeriesDayFormValues,
  WeeklySeriesFormValues,
} from "@/common/components/appointments/plan-attendance/PlanAttendanceDialog.types";
import { attendanceEntrySchema } from "@/common/components/appointments/plan-attendance/PlanAttendanceDialog.utils";

function weeklySeriesDaySchema(t: TFunction): Yup.ObjectSchema<WeeklySeriesDayFormValues> {
  return Yup.object({
    weekday: Yup.mixed<DayOfWeek>().required(),
    entries: Yup.array().of(attendanceEntrySchema(t)).required() as Yup.Schema<AttendanceEntryFormValues[]>,
  });
}

export function weeklySeriesValidationSchema(t: TFunction): Yup.ObjectSchema<WeeklySeriesFormValues> {
  return Yup.object({
    dateFrom: Yup.date()
      .nullable()
      .required(
        t("common.validation.fieldRequired", { fieldName: t("calendar.planAttendance.dateFrom") })
      ) as Yup.Schema<Date | null>,
    dateTo: Yup.date()
      .nullable()
      .required(t("common.validation.fieldRequired", { fieldName: t("calendar.planAttendance.dateTo") }))
      .test("date-to-after-from", t("calendar.planAttendance.dateToBeforeFrom"), function (dateTo) {
        const { dateFrom } = this.parent as Pick<WeeklySeriesFormValues, "dateFrom">;
        if (!dateFrom) {
          return true;
        }
        return dateTo >= dateFrom;
      }) as Yup.Schema<Date | null>,
    days: Yup.array().of(weeklySeriesDaySchema(t)).required() as Yup.Schema<WeeklySeriesDayFormValues[]>,
  });
}
